import request from "@utils/request";
import url from "@utils/url";

const { HOST } = url;

export async function notify() {
    const url = `${HOST}/cps-gateway/api/v1/recommend/notify`;

    return request({ method: "get", url });
}

export async function toCreate(params) {
    const url = `${HOST}/cps-gateway/api/v1/recommend/manage/add`;

    return request({ method: "post", url }, params);
}

export async function toEdit(params) {
    const url = `${HOST}/cps-gateway/api/v1/recommend/manage/update`;

    return request({ method: "post", url }, params);
}

export async function toDelete(params) {
    const url = `${HOST}/cps-gateway/api/v1/recommend/manage/del`;

    return request({ method: "post", url }, params);
}

export async function list(params) {
    const url = `${HOST}/cps-gateway/api/v1/recommend/list`;

    return request({ method: "get", url }, params);
}

